import { get, set } from 'idb-keyval';
function toBase64Url(bytes) {
    const uint8 = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
    let binary = '';
    for (const byte of uint8) {
        binary += String.fromCharCode(byte);
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/u, '');
}
/** 네임스페이스별 디바이스 키 저장소를 만든다. 키는 IndexedDB에 영속한다. */
export function createDeviceKeyStore(storageNamespace) {
    const storageKey = `${storageNamespace}-device-ec-key`;
    let cachedNonce = null;
    function setDpopNonce(nonce) {
        cachedNonce = nonce;
    }
    function getDpopNonce() {
        return cachedNonce;
    }
    async function getOrCreateDeviceKey() {
        try {
            const existing = await get(storageKey);
            if (existing?.privateKey && existing.publicKeyJwk) {
                return existing;
            }
            const keyPair = await crypto.subtle.generateKey({ name: 'ECDSA', namedCurve: 'P-256' }, false, ['sign']);
            const publicJwk = await crypto.subtle.exportKey('jwk', keyPair.publicKey);
            const stored = {
                privateKey: keyPair.privateKey,
                publicKeyJwk: JSON.stringify(publicJwk),
                algorithm: 'ES256',
            };
            await set(storageKey, stored);
            return stored;
        }
        catch {
            return null;
        }
    }
    async function createDpopProof(input) {
        const deviceKey = await getOrCreateDeviceKey();
        if (!deviceKey) {
            return undefined;
        }
        const header = {
            typ: 'dpop+jwt',
            alg: 'ES256',
            jwk: JSON.parse(deviceKey.publicKeyJwk),
        };
        const claims = {
            jti: crypto.randomUUID(),
            htm: input.htm,
            htu: input.htu,
            iat: Math.floor(Date.now() / 1000),
        };
        // 액세스 토큰이 있으면 DPoP를 해당 토큰에 바인딩한다(RFC 9449 ath).
        if (input.accessToken) {
            const athBytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input.accessToken));
            claims.ath = toBase64Url(athBytes);
        }
        if (cachedNonce) {
            claims.nonce = cachedNonce;
        }
        const encodedHeader = toBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = toBase64Url(new TextEncoder().encode(JSON.stringify(claims)));
        const signingInput = `${encodedHeader}.${encodedPayload}`;
        const signature = await crypto.subtle.sign({ name: 'ECDSA', hash: 'SHA-256' }, deviceKey.privateKey, new TextEncoder().encode(signingInput));
        return `${signingInput}.${toBase64Url(signature)}`;
    }
    return { createDpopProof, setDpopNonce, getDpopNonce };
}
//# sourceMappingURL=deviceKey.js.map